import { FcMoneyTransfer } from "react-icons/fc";
import {
  COSTUM,
  DATE,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { HISOBOT } from "../../Component/Sidebar/PageTypes";
import PrintBtn from "./components/PrintBtn";
import Refresh from "./components/Refresh";
const Pribl = {
  title: "Фойда хисоби",
  path: "/hisobot/pribl",
  icon: <FcMoneyTransfer></FcMoneyTransfer>,
  type: HISOBOT,
  allData: [{ value: "mijoz_id", prop: "mijozlar", get: "fio" }],
  hisobotActions: [
    {
      grid: "1fr 1fr 1fr 1fr",
      inputs: [
        {
          label: "Сана",
          name: "sana1",
          type: DATE,
        },
        {
          label: "Сана 2",
          name: "sana2",
          type: DATE,
          secondDate: true,
        },
        {
          type: COSTUM,
          component: (
            <div
              style={{ display: "flex", gridGap: "10px", alignItems: "center" }}
            >
              <Refresh text="Янгилаш"></Refresh>
              <PrintBtn></PrintBtn>
            </div>
          ),
        },
      ],
    },
  ],
};
export default Pribl;
